module.exports = __webpack_public_path__ + "static/media/offerte_color.349d2528.svg";